import React from "react"

import { useUI } from "providers/UIProvider"

import { IMapInputProps } from "./MapInputTypes"

import { Box, Flex, Text } from "@chakra-ui/react"

import Input from "components/UI/atoms/Input"
import Icon from "components/UI/atoms/Icon"
import GoogleMapModal from "components/shared/modals/GoogleMapModal"

const MapInput: React.FC<IMapInputProps> = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  inputStyles,
  coordinates,
  setCoordinates = () => {},
  inputTouched,
  afterClick,
  error
}) => {
  const { T } = useUI()

  const { modals, toggleModal } = useUI()

  const coordinatesError = inputTouched && coordinates === null

  return (
    <Box position="relative">
     <Input
      id={`map-input-${name}`}
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      type="string"
      styles={inputStyles}
      maxLength={30}
      error={Boolean(error)}
      errorMessage={error}
     />
     <Flex
      as="button"
      borderRadius="15px"
      backgroundColor="white"
      boxShadow="primary"
      position="absolute"
      top={`${error ? "36%" : "42%"}`}
      right="20px"
      fontSize="s"
      color="button_grey_bg"
      justifyContent="center"
      alignItems="center"
      padding="10px 12px"
      onClick={()=>toggleModal("googleMapModal", !modals.googleMapModal.isOpened)}
      border={`${coordinatesError ? "1px solid": ""}`}
      borderColor={`${coordinatesError ? "error": ""}`}
     >
      <Icon name="location" iconStyles={{ width: "16px", height: "16px", fill: "var(--chakra-colors-primary)" }} />
      <Text ml="8px">
        {coordinates === null ? T("laundry.form.address_add_marker") : T("laundry.form.address_view_map")}
      </Text>
     </Flex>
     <GoogleMapModal singleMarker={true} coordinates={coordinates} afterClick={afterClick} afterClear={()=>setCoordinates(null)} withActions />
    </Box>
  )
}

export default MapInput
